export const supportive = {
  plum: "#951963",
  blue: "#0078ED",
  green: "#91B000",
  lime: "#BFF02E",
  red: "#EC6879",
  light: {
    plum: "#BF87BF",
    blue: "#91B0FF",
  },
};

export const primary = {
  main: "#E87821",
  mid: "#FF805E",
  light: "#FFF0EB",
};

export const error = {
  main: "#B30909",
  light: "#FEF3F3",
  alert: "#FFC2CA",
};

export const mono = {
  white: "#FFFFFF",
  black: "#000000",
  grey: {
    1: "#D6D6D6",
    2: "#A3A3A3",
    3: "#7A7A7A",
    4: "#525252",
    5: "#292929",
  },
  light: {
    grey: "#EDEFF0",
  },
};

export const omne = {
  orange: {
    mid: "#FFB878",
  },
};

export const background = {
  default: "#F8F9F9",
  paper: "#F8F9F9",
};

export const success = {
  main: "#03824F",
  light: "#E2F5F0",
  alert: "#D6F8E1",
};

export const warning = {
  main: "#FED141",
  light: "#FFF6D9",
};
